<header>
  <h1 mat-dialog-title>AwesomeDocs Config</h1>
  <aside>
    <mat-icon fontIcon="close" [matTooltip]="'Close'" matTooltipShowDelay="500" (click)="discardLocalChanges()"></mat-icon>
  </aside>
</header>
@if (!formReady) {
  <div>
    <h2 style="text-align: center">Loading configuration. Please wait.</h2>
  </div>
}
<form class="adv2-config-form" [hidden]="!formReady" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="tab-scroll">
    <mat-tab-group [dynamicHeight]="true" mat-stretch-tabs="false">
      <mat-tab label="Field Options">
        <app-field-options-tab [formGroup]="fieldOptionsGroup"></app-field-options-tab>
      </mat-tab>
      <mat-tab label="Signature Credentials">
        <ng-template mat-tab-label>
        <span [ngClass]="signatureGroup.invalid ? 'invalid-tab' : 'valid-tab'">
          Signature Credentials
          <mat-icon [fontIcon]="validationIcon"></mat-icon>
        </span>
        </ng-template>
        <app-signature-tab [formGroup]="signatureGroup"></app-signature-tab>
      </mat-tab>
      <mat-tab label="Document Options">
        <app-document-options-tab [formGroup]="documentOptionsGroup"></app-document-options-tab>
      </mat-tab>
      @if (isSalesforceNamespace) {
        <mat-tab label="Salesforce Mapping">
          <app-salesforce-mapping
            [config]="salesforceConfig"
            (configChange)="onSalesforceConfigChange($event)"
            (validityChange)="onSalesforceMappingsValidity($event)"
          ></app-salesforce-mapping>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
  <section class="footer-btns">
    <button class="danger-btn-hover" (click)="discardLocalChanges($event)">cancel</button>
    <button
      type="submit"
      [disabled]="
        !form.valid || (!isNewClient && !form.dirty) || (isSalesforceNamespace && !hasValidSalesforceMappings)">
      save
    </button>
  </section>
</form>
